export const buildPrizeBreakdown = (results) => {
  if (!results || results.length === 0) {
    return [];
  }

  const bowlerPrizes = {};

  results.forEach((result) => {
    if (result.isIndividualEvent) {
      const bowlerId = result.bowlerId;
      const bowlerName = result.bowlerName;

      if (!bowlerId || !bowlerName) return;

      if (!bowlerPrizes[bowlerId]) {
        bowlerPrizes[bowlerId] = {
          bowlerId,
          bowlerName,
          totalPrizes: 0,
          events: [],
          teamPrizes: 0,
          individualPrizes: 0,
        };
      }

      const prize = result.prize || 0;
      const eventInfo = {
        eventId: result.eventId,
        eventName: result.eventName || "Unknown Event",
        position: result.position,
        prize: prize,
        isIndividualEvent: true,
        teamName: null,
        teamId: result.teamId,
        tieDescription: result.tieDescription,
      };

      if (prize > 0) {
        bowlerPrizes[bowlerId].events.push(eventInfo);
        bowlerPrizes[bowlerId].totalPrizes += prize;
        bowlerPrizes[bowlerId].individualPrizes += prize;
      }
    } else {
      const teamPrize = result.prize || 0;
      const teamBowlers = result.bowlers || [];
      const bowlerIds = result.bowlerIds || [];

      if (teamBowlers.length === 0 || bowlerIds.length === 0) return;

      const prizePerBowler = teamPrize / teamBowlers.length;

      teamBowlers.forEach((bowler) => {
        const bowlerId = bowler.id;
        const bowlerName = bowler.name;

        if (!bowlerId || !bowlerName) return;

        if (!bowlerPrizes[bowlerId]) {
          bowlerPrizes[bowlerId] = {
            bowlerId,
            bowlerName,
            totalPrizes: 0,
            events: [],
            teamPrizes: 0,
            individualPrizes: 0,
          };
        }

        const eventInfo = {
          eventId: result.eventId,
          eventName: result.eventName || "Unknown Event",
          position: result.position,
          prize: prizePerBowler,
          isIndividualEvent: false,
          teamName: result.teamName,
          teamId: result.teamId,
          tieDescription: result.tieDescription,
        };

        if (prizePerBowler > 0) {
          bowlerPrizes[bowlerId].events.push(eventInfo);
          bowlerPrizes[bowlerId].totalPrizes += prizePerBowler;
          bowlerPrizes[bowlerId].teamPrizes += prizePerBowler;
        }
      });
    }
  });

  return Object.values(bowlerPrizes)
    .filter((bowler) => bowler.totalPrizes > 0 && bowler.events.length > 0)
    .sort((a, b) => b.totalPrizes - a.totalPrizes);
};
